const isInViewport = (el) => {
  let windowWidth = window.innerWidth;

  if (windowWidth > 1024) {
    return;
  }

  if (el) {
    let elTop = el.getBoundingClientRect().top + window.scrollY,
      elBottom = elTop + el.clientHeight,
      viewportTop = document.documentElement.scrollTop,
      viewportBottom = viewportTop + window.innerHeight;

    if (elTop) {
      return elBottom > viewportTop && elTop < viewportBottom;
    }
  }
};

const stickyCart = () => {
  const productControlsContainer = document.querySelectorAll(".product-controls-container")[0];

  const stickyAddToCart = document.querySelector(".sticky-add-to-cart");

  if (!stickyAddToCart || !productControlsContainer) return;

  if (isInViewport(productControlsContainer)) {
    if (stickyAddToCart.classList.contains("active")) {
      stickyAddToCart.classList.remove("active");
    }
  } else {
    stickyAddToCart.classList.add("active");
  }
};

const warrningModal = () => {
  const toggleBtns = document.querySelectorAll(".toggle-warning-modal"),
    closeBtn = document.querySelector(".close-warning-modal"),
    warningModal = document.querySelector(".warning-modal-wrapper"),
    noticeWrapper = document.querySelector(".product-notice-wrapper"),
    noticeAgreeBtn = document.querySelector(".product-warning-container .product-notice-agree-btn"),
    actionsAgreeBtn = document.querySelector(".actions-wrapper .product-notice-agree-btn"),
    noticeCheckbox = document.querySelector(".product-notice-box"),
    swatches = [...document.querySelectorAll(".option-element")],
    swatchDropdown = [...document.querySelectorAll(".swatch-dropdown")];

  if (!toggleBtns.length || !noticeAgreeBtn || !noticeWrapper) return;

  toggleBtns.forEach((btn) => {
    btn.addEventListener("click", function () {
      warningModal.classList.add("show");
      noticeAgreeBtn.disabled = false;
    });
  });

  noticeWrapper.addEventListener("click", function () {
    warningModal.classList.remove("show");
    noticeAgreeBtn.disabled = false;
  });

  closeBtn.addEventListener("click", function () {
    warningModal.classList.remove("show");
  });

  noticeAgreeBtn.addEventListener("click", function () {
    warningModal.classList.remove("show");
    noticeCheckbox.checked = true;
    actionsAgreeBtn.disabled = false;

    swatches.forEach((swatch) => {
      if (!swatch.classList.contains("active")) {
        swatch.disabled = false;
        swatch.classList.add("active");
      }
    });

    swatchDropdown.forEach((swatch) => {
      if (!swatch.classList.contains("active")) {
        swatch.disabled = false;
        swatch.classList.add("active");
      }
    });

    document.querySelectorAll(".product-controls-container .product-notice-agree-btn").forEach((btn) => btn.remove());

    if (document.querySelectorAll(".payment-button-wrapper").length > 0) {
      document.querySelector(".cloned-addtocart-button, .payment-button-wrapper").style = "display: block;";
      document.querySelector(".payment-button-wrapper").style = "display: block;";
    }

    document.querySelectorAll(".product-form__submit").forEach((btn) => (btn.style = "display: block"));
  });
};

const productPageImage = () => {
  const mainImg = this.document.querySelector(".product__media-list");
  const carousel = this.document.querySelector(".product__media-list-container");

  if (!mainImg || !carousel) return;

  let mainImgHeight = mainImg.getBoundingClientRect().height;
  this.document.querySelector(".product__media-list-container").style = `height: ${mainImgHeight}px`;
};

const shippingCostsModal = () => {
  if (document.querySelectorAll(".shipping-cost-table-headers th").length > 3) {
    document.querySelector(".shipping-cost-table").classList.add("overflow-x");
    document.querySelector(".shipping-cost-table tbody").classList.add("width-with-scroll");
  }
};

const productClearCart = () => {
  const onlyItemNotice = document.querySelector(".only-item-notice");
  const editCartPopup = document.querySelector("#ProductPopup-edit-cart");
  const buttonsWrapper = document.querySelector(".buttons-wrapper");
  const emptyCartBtns = document.querySelectorAll(
    ".empty-cart-actions .button-group .empty-cart, .edit-cart-modal .empty-cart",
  );

  if (onlyItemNotice && editCartPopup) {
    if (buttonsWrapper) {
      buttonsWrapper.display = "none";
    }
    document.querySelectorAll(".product-notice-banner, .sticky-add-to-cart .product-notice").forEach((el) => {
      el.style.pointerEvents = "none";
    });
  } else {
    if (buttonsWrapper) {
      buttonsWrapper.style = "";
    }

    document.querySelectorAll(".product-notice-banner, .sticky-add-to-cart .product-notice").forEach((el) => {
      el.style.pointerEvents = "auto";
    });
  }

  if (document.querySelector(".empty-cart-actions .button-group .empty-car")) {
    document
      .querySelectorAll("variant-radios, .product-form__quantity, .cta-buttons-wrapper, .swatch-dropdown")
      .forEach((el) => {
        el.style.display = "none";
      });
  } else {
    document
      .querySelectorAll("variant-radios, .product-form__quantity, .cta-buttons-wrapper, .swatch-dropdown")
      .forEach((el) => {
        el.style = "";
      });
  }

  if (emptyCartBtns.length > 0) {
    emptyCartBtns.forEach((btn) => {
      btn.addEventListener("click", async function (e) {
        e.preventDefault();
        try {
          const res = await fetch("/cart/clear.js", {
            method: "POST",
          });

          if (res.ok) {
            document.querySelector(".cart-count-bubble > span").textContent = "0";
            document.querySelector(".only-item-notice")?.classList?.remove("only-item-notice");

            document
              .querySelectorAll(
                "variant-radios, .product-form__quantity, .cta-buttons-wrapper, .swatch-dropdown, .product-notice, .sticky-add-to-cart :nth-child(3)",
              )
              .forEach((el) => (el.style = ""));
            document
              .querySelectorAll(".empty-cart-actions, .cloned-empty-cart-actions, .product-notice-only-item")
              .forEach((el) => (el.style.display = "none"));
            document.querySelector("#PopupModal-edit-cart").removeAttribute("open");
            document.body.classList.remove("overflow-hidden");
            document.querySelector(".buttons-wrapper").style = "";
            document
              .querySelectorAll(".product-notice-banner, .sticky-add-to-cart .product-notice")
              .forEach((el) => (el.style = "pointer-events: auto"));
            if (editCartPopup) {
              editCartPopup.remove();
            }
          } else {
            console.error("Something went wrong Clearing Cart");
          }
        } catch (e) {
          console.error("Something went wrong Clearing Cart", e);
        }
      });
    });
  } else {
    document
      .querySelectorAll("variant-radios, .product-form__quantity, .cta-buttons-wrapper, .swatch-dropdown")
      .forEach((el) => {
        el.style = "";
      });
  }
};

class StickySwatches {
  constructor() {
    this.swatch = document.querySelector("variant-radios");
    this.variantsSelects = document.querySelector("variant-selects");
    this.swatchRadio = document.querySelectorAll('.product-variant-options-wrapper input[type="radio"]');
    this.stickyAddToCartWrapper = document.querySelector(".sticky-add-to-cart");
    this.swatchDropdownTrigger = document.querySelectorAll(".swatch-dropdown-trigger");
    this.swatchDropdownModal = document.querySelectorAll(".swatch-dropdown-modal");
    this.dropdownItemOption = document.querySelectorAll(".dropdown-item-option");
    this.productDetailsWrapper = document.querySelector(".product__info-wrapper");
    this.clonedAddTocartWrapper = document.querySelector(".cloned-addtocart-button");
    this.stickySwatches = document.querySelector("#stickySwatches");

    this.init();
  }
  setSoldoutOptions() {
    const swatchDropdownModals = [...document.querySelectorAll(".swatch-dropdown-modal ul")];

    if (this.swatch) {
      const variantOptions = [...document.querySelectorAll(".product-variant-options-wrapper")];

      for (let i = 0; i < swatchDropdownModals.length; i++) {
        for (let j = 0; j < swatchDropdownModals[i].children.length; j++) {
          if (variantOptions[i]?.children[j]?.children[0]?.classList?.contains("disabled")) {
            swatchDropdownModals[i].children[j].classList.remove("available");
            swatchDropdownModals[i].children[j].classList.add("disabled");
            swatchDropdownModals[i].children[j].classList.add("soldout");
            swatchDropdownModals[i].children[j].classList.add("klaviyo-bis-trigger");
          } else {
            swatchDropdownModals[i].children[j].classList.remove("disabled");
            swatchDropdownModals[i].children[j].classList.remove("soldout");
            swatchDropdownModals[i].children[j].classList.remove("klaviyo-bis-trigger");
            swatchDropdownModals[i].children[j].classList.add("available");
          }
        }
      }
    }
  }
  getDropdownOption(swatchRadioElem) {
    var optionIndex = document.querySelector(swatchRadioElem).parentElement.parentElement.getAttribute("option-index");
    var optionValue = swatchRadioElem.value;

    var selectedDropdown = this.stickyAddToCartWrapper.querySelector("[data-dropdown-index='" + optionIndex + "']");

    selectedDropdown.querySelectorAll("li").forEach((li) => {
      li.removeClass("selected");
    });

    var selectedOption = selectedDropdown.querySelector("li[data-value='" + optionValue + "']");
    selectedOption.classList.add("selected");

    selectedDropdown.querySelector(".swatch-dropdown-trigger").texContent = optionValue;
  }
  closeModal() {
    this.swatchDropdownModal.forEach((modal) => {
      modal.classList.remove("modal-open");
    });
  }

  cloneEmptyCartButton() {
    const emptyCartActionsForm = document.querySelector(".empty-cart-actions .form");

    const clonedActionsFormElement = document.querySelector(".cloned-empty-cart-actions");

    if (!emptyCartActionsForm) return;

    const emptyCartActionFormElement = emptyCartActionsForm.cloneNode(true);

    clonedActionsFormElement.appendChild(emptyCartActionFormElement);
  }
  init() {
    var _that = this;

    this.swatchDropdownTrigger.forEach((trigger) => {
      trigger.addEventListener("click", function () {
        _that.closeModal();
        this.nextElementSibling.classList.toggle("modal-open");
        _that.setSoldoutOptions();
      });
    });

    document.querySelectorAll(".close-swatch-modal").forEach((close) => {
      close.addEventListener("click", function () {
        _that.closeModal();
      });
    });

    this.setSoldoutOptions();
    this.cloneEmptyCartButton();

    if (this.swatch) {
      this.dropdownItemOption.forEach((option) => {
        option.addEventListener("click", function () {
          const swatchValue = option.dataset.value;
          const swatchItem = _that.swatch.querySelector("input[value='" + swatchValue + "']");
          const swatchName = swatchItem.getAttribute("name");
          const stickySwatchFormInput = _that.stickySwatches.querySelector(`input[name=${swatchName}]`);
          stickySwatchFormInput.value = swatchValue;
          swatchItem.dispatchEvent(new MouseEvent("click"));
          _that.closeModal();
        });
      });
    } else {
      this.dropdownItemOption.forEach((option) => {
        option.addEventListener("click", function () {
          const optionValue = option.dataset.value;
          const optionVariant = option.dataset.variant;
          const variantSelect = _that.variantsSelects.querySelector("select[name='options[" + optionVariant + "]']");
          const stickySwatchFormInput = _that.stickySwatches.querySelector(`input[name=${optionVariant}]`);
          variantSelect.value = optionValue;
          stickySwatchFormInput.value = optionValue;

          variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
          _that.closeModal();
        });
      });
    }
  }
}

class PriceWithDynamicTaxes {
  constructor() {
    this.countriesWithDynamicTaxes = [
      "AT",
      "BE",
      "BG",
      "HR",
      "CY",
      "CZ",
      "DK",
      "EE",
      "FI",
      "FR",
      "DE",
      "GR",
      "HU",
      "IE",
      "IT",
      "LV",
      "LT",
      "LU",
      "MT",
      "NL",
      "PL",
      "PT",
      "RO",
      "SK",
      "SI",
      "ES",
      "SE",
      "GB",
    ];
  }
  addNoteAboutVat(countryCode) {
    const checkLocalizationCountry = this.countriesWithDynamicTaxes.some((element) => {
      return element === countryCode;
    });

    if (checkLocalizationCountry) {
      const infoElement = document.querySelectorAll(".price-taxes-info");
      infoElement.forEach((element) => {
        const spanElement = document.createElement("span");
        spanElement.classList.add("taxes-note");
        spanElement.setAttribute("id", "taxes-note");
        spanElement.textContent = `*${window.variantStrings.include_taxes}`;
        element.appendChild(spanElement);
      });
    }
  }
}

window.StickySwatches = new StickySwatches();
window.PriceWithDynamicTaxes = new PriceWithDynamicTaxes();
window.addEventListener("resize", stickyCart);
window.addEventListener("scroll", stickyCart);
window.addEventListener("resize", productPageImage);
window.dispatchEvent(new Event("resize"));
warrningModal();
productClearCart();
